import type { ReactElement } from 'react';
import { useAuth } from 'react-oidc-context';

import { AppLayout } from '@/layouts/app-layout';
import { FullWidthConstrainedLayout } from '@/layouts/full-width-constrained-layout';

type ErrorsPageProps = {
  children: ReactElement[] | ReactElement;
};

export function ErrorsPage({ children }: ErrorsPageProps): ReactElement {
  const { user } = useAuth();

  return user ? (
    <AppLayout>{children}</AppLayout>
  ) : (
    <div className='flex h-screen w-screen overflow-hidden'>
      <div className='flex grow flex-col overflow-y-auto'>
        <FullWidthConstrainedLayout>{children}</FullWidthConstrainedLayout>
      </div>
    </div>
  );
}
